import { LogicalOperatorType, } from '@iotv/iotv-v3-types';
import { getFiltetedItemsByType } from './wideawakeDataFns';
import { NodeEdgeMapper } from '@iotv/datamodel-core';
const debug = process.env.REACT_APP_DEBUG && false;
const QUERY_LIMIT = 3000;
const ITERATION_LIMIT = 10;
const delay = async (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export const iterateQueryWithSource = async (type, filterAnd, filters) => {
    let ExclusiveStartKey = undefined;
    let directTemplate = {
        nodeFilterGroups: [
            {
                filters,
                setOperation: filterAnd ? LogicalOperatorType.AND : LogicalOperatorType.OR,
            },
        ],
        Limit: QUERY_LIMIT,
        ExclusiveStartKey,
    };
    let objectList = [];
    let iterate = 0;
    let reset = false;
    do {
        let res;
        res = await getFiltetedItemsByType(type, { ...directTemplate, ExclusiveStartKey });
        if (res.err === null && res.data !== null) {
            reset = false;
            objectList.push(...res.data.Items);
            // exit on small (can be removed on undefined change)
            if ((res.data.Items.length < QUERY_LIMIT && ExclusiveStartKey === undefined) || ExclusiveStartKey === res.data.LastEvaluatedKey) {
                debug && console.log('LENGTH', res.data.Items.length);
                break;
            }
            ExclusiveStartKey = res.data.LastEvaluatedKey;
            iterate++;
        }
        else {
            if (reset) {
                debug && console.log('Failed GetByType Query', res.err);
                return objectList;
            }
            debug && console.log('TRY AGAIN', res.err);
            reset = true;
        }
        debug && console.log('Iteration', iterate);
        await delay(200);
    } while (ExclusiveStartKey !== undefined && iterate < ITERATION_LIMIT); // current restriction to stop it
    return objectList;
};
export const getObjectsCombined = async (type, filters) => {
    let ExclusiveStartKey = undefined;
    let template = {
        nodeFilterGroups: [
            {
                filters,
                setOperation: LogicalOperatorType.AND,
            },
        ],
        Limit: QUERY_LIMIT,
        ExclusiveStartKey,
    };
    let objectList = [];
    let iterate = 0;
    let reset = false;
    do {
        let res = await getFiltetedItemsByType(type, {
            ...template,
            ExclusiveStartKey,
        });
        if (res.err === null && res.data !== null) {
            reset = false;
            ExclusiveStartKey = res.data.LastEvaluatedKey;
            objectList.push(...res.data.Items);
            // exit on small (can be removed on undefined change)
            if (res.data.Items.length < QUERY_LIMIT) {
                debug && console.log('LENGTH', res.data.Items.length);
                break;
            }
            iterate++;
        }
        else {
            if (reset) {
                debug && console.log('Failed GetByType Query', res.err);
                return objectList;
            }
            debug && console.log('TRY AGAIN', res.err);
            reset = true;
        }
        debug && console.log('Iteration', iterate);
        await delay(500);
    } while (ExclusiveStartKey !== undefined && iterate < 8); // current restriction to stop it
    return objectList;
};
export const getObjectsCombinedOR = async (type, filters) => {
    let ExclusiveStartKey = undefined;
    let template = {
        nodeFilterGroups: [
            {
                filters,
                setOperation: LogicalOperatorType.OR,
            },
        ],
        Limit: QUERY_LIMIT,
        ExclusiveStartKey,
    };
    let objectList = [];
    let iterate = 0;
    let reset = false;
    do {
        let res = await getFiltetedItemsByType(type, {
            ...template,
            ExclusiveStartKey,
        });
        if (res.err === null && res.data !== null) {
            reset = false;
            ExclusiveStartKey = res.data.LastEvaluatedKey;
            objectList.push(...res.data.Items);
            // exit on small (can be removed on undefined change)
            if (res.data.Items.length < QUERY_LIMIT) {
                debug && console.log('LENGTH', res.data.Items.length);
                break;
            }
            iterate++;
        }
        else {
            if (reset) {
                debug && console.log('Failed GetByType Query', res.err);
                return objectList;
            }
            debug && console.log('TRY AGAIN', res.err);
            reset = true;
        }
        debug && console.log('Iteration', iterate);
        await delay(500);
    } while (ExclusiveStartKey !== undefined && iterate < 8); // current restriction to stop it
    // filter out uniques if required
    // let result: ValidBusinessObjectList = [];
    // let lookup: { [k: string]: number } = {};
    // objectList.forEach((object) => {
    //   var id = object.id;
    //   if (!(id in lookup)) {
    //     lookup[id] = 1;
    //     result.push(object);
    //   }
    // });
    // return result;
    return objectList;
};
export const queryByGraphFormatter = (data) => {
    if (data.err === null && data.data !== null) {
        const foundMapper = new NodeEdgeMapper(data.data.nodeEdgeMapper);
        let deviceList = foundMapper.getNodesOfType('Device');
        return deviceList;
    }
    return [];
};
